import cn from "mcn";

export function ActionsIcon({
  selected,
  ...props
}: React.HTMLAttributes<SVGSVGElement> & {
  selected?: boolean;
}) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: We have a custom tooltip
    <svg
      width="5.625"
      height="20.625"
      viewBox="0 0 5 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn(selected ? "nav-icon selected" : "nav-icon", props.className)}
    >
      <circle cx="2.5" cy="2.5" r="2.5" fill="white" className="fill-orange" />
      <circle cx="2.5" cy="9" r="2.5" fill="white" className="fill-orange" />
      <circle cx="2.5" cy="15.5" r="2.5" fill="white" className="fill-orange" />
    </svg>
  );
}
